import axios from "axios";
import { ContextModel } from "models";
import React from "react";
import { Link, useNavigate, NavLink } from "react-router-dom";
import { Utils } from "utils";

type PROPS = {
  ctx: ContextModel;
};

const Header: React.FC<PROPS> = (props) => {
  const navigate = useNavigate();

  const onCorpIconClick = async () => {
    const result = window.confirm("ログアウトしますか？");
    if (!result) {
      return;
    }

    props.ctx.loading.setState(true);
    try {
      const response = await axios.post("/api.d/v1/auth/login-token/logout");
      const { location = '/' } = response.data.data;
      Utils.Store.logout();
      window.location.assign(location);
    } catch (err) {
      Utils.errorAction(props.ctx, err);
    }
    props.ctx.loading.setState(false);
  };

  return (
    <div className="jhk-header p-4 border border-b">
      <div
        className="mx-auto flex justify-between items-center"
        style={{ maxWidth: "1920px" }}
      >
        <Link to="/mypage/">
          <img src={`${process.env.PUBLIC_URL}/trust-linkage-logo.png`} alt="logo" className="w-40" />
        </Link>

        <div className="flex gap-4">
          <NavLink to="/item-list?get_count=10" className="btn ">商品一覧</NavLink>
          <NavLink to="/company-list?get_count=10" className="btn">会社一覧</NavLink>
        </div>
        <div className="flex gap-4">
          {!props.ctx.auth.data?.is_admin_corp && (
            <>
              <NavLink to="/candidate-company/" className="btn">商談候補会社</NavLink>
              <NavLink to="/candidate-item/" className="btn">商談候補商品</NavLink>
            </>
          )}
        </div>
        <button className="btn " onClick={onCorpIconClick}>
          ログアウト
        </button>
      </div>
    </div>
  );
};

export default Header;
